<button mat-icon-button [matMenuTriggerFor]='menu' aria-label='Menu utilisateur' color='primary'>
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #menu='matMenu'>
  <button mat-menu-item (click)='loadConfiguration()'>
    <mat-icon>file_upload</mat-icon>
    <span>Charger une configuration</span>
  </button>
  <button mat-menu-item (click)='saveConfiguration()'>
    <mat-icon>save</mat-icon>
    <span>Sauvegarder la configuration</span>
  </button>
  <button mat-menu-item (click)='logout()' [disabled]='!(user$|async)'>
    <mat-icon>logout</mat-icon>
    <span>Se déconnecter</span>
  </button>
  <button mat-menu-item (click)='updateTheme()'>
    <mat-icon>dark_mode</mat-icon>
    <span>Thème {{theme === 'dark' ? 'clair' : 'sombre'}}</span>
  </button>
  <button mat-menu-item (click)='toggleConsoleAdmin()'>
    <mat-icon>monitor_heart</mat-icon>
    <span style='margin-right: 16px;'>Connexions serveurs</span>
    <mat-icon
      [style.color]="(kafkaService.active$|async) === 'Connected' ? 'green': 'red'">
      {{(kafkaService.active$|async) === 'Connected' ? 'wifi' : 'wifi_off'}}
    </mat-icon>
  </button>
</mat-menu>

<mat-icon>account_circle</mat-icon>
<span *ngIf='user$|async'>{{(user$|async)?.name}}</span>
